import { render, staticRenderFns } from "./AutomationTemplatesSellsy.vue?vue&type=template&id=6ddf600a&scoped=true&"
import script from "./AutomationTemplatesSellsy.vue?vue&type=script&lang=js&"
export * from "./AutomationTemplatesSellsy.vue?vue&type=script&lang=js&"
import style0 from "./AutomationTemplatesSellsy.vue?vue&type=style&index=0&id=6ddf600a&prod&lang=scss&scoped=true&"
import style1 from "./AutomationTemplatesSellsy.vue?vue&type=style&index=1&id=6ddf600a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddf600a",
  null
  
)

export default component.exports